import { basicBaseApi } from "./basicBaseApi";
import { Methods } from '@newview/infrastructure';


export class BusinessactionApi extends basicBaseApi {

  public get ControllerName(): any {
    return 'businessaction'
  }

  
  /**
   * 
   * @returns 
   */
  public getBusinessactionList(){
    return this.send({},"getBusinessactionList",Methods.GET)
  }


  public savesBusinessaction(businessactions){
    return this.send(businessactions,"savesBusinessaction",Methods.POST)
  }
}